import { RequestKind, boolean } from '@sb/library/base';
import { BatchInvoiceUpdateItem, DisplayItemCollection, EmailPreviewDisplayItem, GenericInvoiceInputItem, InvoiceDetailsDisplayItem, InvoiceDisplayItem, InvoiceEmailInputItem, InvoiceEmailRenderInputItem, InvoiceSearchOptions, InvoiceStatusUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace InvoicesRoutes {
    export const Search = ApiRoute.Define({
        URL: 'search/invoices',
        Kind: RequestKind.Post,
        BodyType: InvoiceSearchOptions,
        ResultType: DisplayItemCollection<InvoiceDisplayItem>,
        RequestedFieldsType: InvoiceDisplayItem,
        OrderByType: InvoiceDisplayItem,
        PagingAllowed: true
    });

    export const Delete = ApiRoute.Define({
        URL: (invoiceID: string) => `invoices/${invoiceID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Get = ApiRoute.Define({
        URL: (invoiceID: string) => `invoices/${invoiceID}`,
        Kind: RequestKind.Get,
        ResultType: InvoiceDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: 'invoices',
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<InvoiceDisplayItem>,
        PagingAllowed: true
    });

    export const Email = ApiRoute.Define({
        URL: (invoiceID: string) => `invoices/${invoiceID}/email`,
        Kind: RequestKind.Post,
        BodyType: InvoiceEmailInputItem,
        ResultType: boolean
    });

    export const ChangeStatus = ApiRoute.Define({
        URL: (invoiceID: string) => `invoices/${invoiceID}/status`,
        Kind: RequestKind.Patch,
        BodyType: InvoiceStatusUpdateItem,
        ResultType: boolean
    });

    export const Batch = ApiRoute.Define({
        URL: 'invoices',
        Kind: RequestKind.Patch,
        BodyType: BatchInvoiceUpdateItem,
        ResultType: boolean
    });

    export const RenderEmail = ApiRoute.Define({
        URL: (invoiceID: string) => `invoices/${invoiceID}/renderemail`,
        Kind: RequestKind.Post,
        BodyType: InvoiceEmailRenderInputItem,
        ResultType: EmailPreviewDisplayItem
    });

    export const Add = ApiRoute.Define({
        URL: 'invoices',
        Kind: RequestKind.Post,
        BodyType: GenericInvoiceInputItem,
        ResultType: Array<string>,
    });

    export const GetLimitedDetails = ApiRoute.Define({
        URL: (schoolID: string, invoiceDetailsID: string) => `schools/${schoolID}/invoicedetails/${invoiceDetailsID}`,
        Kind: RequestKind.Get,
        ResultType: InvoiceDetailsDisplayItem
    });
}
